<template>
    <div class="sec-filing-task-item loading-container" style="height: 100%">
        <loading :active="updating" :is-full-page="false" />
        <div class="task-body">
            <router-link :to="link" target="_blank" class="button primary"> Edit Compensation </router-link>
            <p>{{ item.description }}</p>
        </div>
        <div class="task-actions">
            <button @click="ignore" class="danger">Clear</button>
        </div>
    </div>
</template>
<script setup>
import SecFilingService from '@/services/secFilingService.js'
import TaskService from '@/services/manage/taskService'
import { asyncComputed } from '@/utils/asyncComputed'
import { computed, inject } from 'vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const filing = asyncComputed(() => SecFilingService.get(props.item.secondaryEntityId), null)

const metadata = computed(() => filing.value?.metadata ?? {})
const link = computed(() => ({
    name: 'manage-tools',
    params: { tool: 'ProxyCompensationEditor' },
    query: { accessionNumber: metadata.value.accessionNumber },
}))
const updating = computed(() => filing.updating)

const flash = inject('flash')

async function ignore() {
    await TaskService.complete(this.item)
    flash('Task cleared.', 'success')
}
</script>
<style>
.sec-filing-task-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;

    .task-body {
        flex-grow: 1;
    }
}
</style>
